import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { SelectDecorator } from '../../components/SelectDecorator/SelectDecorator';
import { CanvasAppContext, CanvasAppContextProps, Order } from '../common/typings';

import * as keyset from './RecentOrderSelector.i18n';

const i18n = i18nFactory(keyset);

export interface RecentOrderSelectorProps {
    cls?: string;
    value?: Order;
    change: (order: Order) => void;
}

const dataProvider = [
    {
        val: Order.DESC,
        text: i18n('desc-order'),
        key: Order.DESC
    },
    {
        val: Order.ASC,
        text: i18n('asc-order'),
        key: Order.ASC
    }
];

export class RecentOrderSelector extends React.PureComponent<RecentOrderSelectorProps> {
    render() {
        const selectedItem = dataProvider.find(item => item.val === this.props.value);
        const btnText = selectedItem ? selectedItem.text : i18n('order-by-date-label');

        return (
            <CanvasAppContext.Consumer>
                {({ parent }: CanvasAppContextProps) => (
                    <SelectDecorator
                        cls={this.props.cls}
                        theme={'normal'}
                        size={'s'}
                        type={'radio'}
                        items={dataProvider}
                        onChange={this.onChange}
                        width={'max'}
                        val={this.props.value}
                        button={{ text: btnText }}
                        popup={{
                            scope: parent || undefined
                        }}
                    />
                )}
            </CanvasAppContext.Consumer>
        );
    }

    private onChange = (orders: Order[]): void => {
        this.props.change(orders[0]);
    };
}
